'use strict';

exports.__esModule = true;
var MISSING_ICONS_DICTIONARY = exports.MISSING_ICONS_DICTIONARY = {
  'general_practitioner': 'default_specialty_icon',
  'specialty': 'default_specialty_icon',
  'procedure': 'scalpel',
  'cosmetic_doctor': 'default_specialty_icon'
};


// WEBPACK FOOTER //
// ./components/specialty-svg-icon/lib/utils/constants.js